import React, {Component} from "react";
import Paper from "@material-ui/core/Paper";
import {Divider} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";

const Manual2FAView = () => {
    return (
        <Paper elevation={5}
               style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>

            <div className="p-grid">
                <div className="p-col-12">
                    <Typography variant="h5" style={{fontWeight: "bolder", textAlign: 'center'}} className="title-page-presval">
                        Manual de Configuración
                    </Typography>
                    <Typography variant="h6" style={{textAlign: 'center'}} className="subtitle-manual">
                        Verificación en Dos Pasos
                    </Typography>
                    <Divider/>
                    <p>
                        Bienvenido a <b>MEIPresval</b>. Para asegurar que tu información y tus operaciones de
                        préstamo de valores estén protegidas, hemos implementado una capa de seguridad
                        adicional. Sigue estos pasos para configurar tu cuenta.
                    </p>
                    <p style={{color: '#757575'}} >&#9647; Este proceso toma menos de 5 minutos.</p>
                    <Typography variant="h6" style={{fontWeight: "bolder"}} className="title-page-presval">
                        Requisitos previos
                    </Typography>
                    <p>Antes de comenzar, asegúrate de contar con lo siguiente:</p>
                    <ul>
                        <li>Teléfono celular con cámara funcional.</li>
                        <li>Conexión a internet en tu celular para descargar la aplicación.</li>
                        <li>Acceso a la página de <b>MEIPresval</b> desde tu computadora.</li>
                    </ul>

                    <Typography variant="h6" style={{fontWeight: "bolder"}} className="title-page-presval">
                        Paso 1: Descarga la aplicación
                    </Typography>
                    <p>Descarga la aplicación <b>Google Authenticator</b> en tu teléfono celular. Esta aplicación
                        generará los códigos de seguridad necesarios para entrar. </p>
                    <ul>
                        <li>Si tienes iPhone: búscala en la <b>App Store.</b></li>
                        <li>Si tienes Android: búscala en la <b>Google Play Store.</b></li>
                    </ul>

                    <Typography variant="h6" style={{fontWeight: "bolder"}} className="title-page-presval">
                        Paso 2: Inicia sesión en MEIPresval
                    </Typography>
                    <ul>
                        <li>Entra a la página de <b>MEIPresval</b> con tu usuario y contraseña habituales.  </li>
                        <li>Da clic en <b>LOGIN.</b> El sistema detectará que aún no tienes configurada tu seguridad
                            y te mostrará un aviso indicando que debes activar la verificación en dos pasos.  </li>
                        <li>Da clic en el botón <b>“Configurar ahora”</b>. El sistema mostrará en pantalla un <b>código QR</b> que
                            deberás escanear con tu celular en el siguiente paso.</li>
                    </ul>

                    <Typography variant="h6" style={{fontWeight: "bolder"}} className="title-page-presval">
                        Paso 3: Vincula tu cuenta
                    </Typography>
                    <Typography variant="h7" style={{fontWeight: "bolder"}} className="subtitle-manual">
                        &#9647; En tu celular
                    </Typography>
                    <ul>
                        <li>Abre la aplicación <b>Google Authenticator.</b> </li>
                        <li>En la pantalla de bienvenida, si cuentas con una cuenta de <b>Gmail</b> podrás
                            configurarla; si no tienes cuenta de Gmail, puedes continuar sin una.</li>
                        <li>Al seleccionar cualquiera de las dos opciones, la app mostrará la pantalla de inicio
                            de configuración.  </li>
                        <li>Toca el símbolo <b>“+”</b> que aparece en la esquina inferior derecha de la aplicación. </li>
                        <li>Selecciona la opción <b>“Escanear código QR”.</b> </li>
                    </ul>

                    <Typography variant="h7" style={{fontWeight: "bolder"}} className="subtitle-manual">
                        &#9647; En tu computadora
                    </Typography>
                    <ul>
                        <li>Apunta la cámara de tu celular hacia el <b>código QR</b> que aparece en la pantalla de tu
                            computadora y escánealo.    </li>
                        <li>Una vez escaneado, verás en tu celular una nueva cuenta llamada <b>MEIPresval:
                            (Nombre del usuario)</b> con un código de 6 números que cambia cada 30 segundos.</li>
                    </ul>
                </div>
                <div className="p-col-12" style={{paddingTop: '1%', paddingBottom: '1%', paddingLeft: '5%', paddingRight: '10%'}}>
                    <Divider/>
                    <p><span className="subtitle-manual"><b>&#9647; Si la cámara no puede leer el código QR:</b></span> en
                        la misma pantalla encontrarás una opción de <b>“Ingresar clave manualmente”</b>. Cópiala y úsala
                        directamente en <b>Google Authenticator </b> seleccionando <b>“Ingresar clave de configuración”</b> en
                        lugar de escanear.</p>
                    <Divider/>
                </div>
                <div className="p-col-12">
                    <Typography variant="h6" style={{fontWeight: "bolder"}} className="title-page-presval">
                        Paso 4: Activa y Verifica
                    </Typography>
                    <ul>
                        <li>Escribe los 6 números que ves en tu celular dentro del recuadro en tu computadora.</li>
                        <li>Da clic en el botón <b>“Verificar y Aplicar”.</b>  </li>
                        <li>Accederás a la pantalla principal de MEIPresval.  </li>
                    </ul>
                    <Typography variant="h6" style={{textAlign: 'center', color:'#6A9A23'}}>
                        ¡Tu cuenta ahora es segura!
                    </Typography>

                    <Typography variant="h6" style={{fontWeight: "bolder"}} className="title-page-presval">
                        Paso 5: Cómo iniciar sesión a partir de ahora
                    </Typography>
                    <p>Una vez configurada la verificación, cada vez que accedas a MEIPresval el flujo será el
                        siguiente: </p>
                    <ul>
                        <li>Ingresa tu <b>usuario y contraseña</b> en la página de <b>MEIPresval</b> y da clic en <b>LOGIN.</b></li>
                        <li>El sistema te pedirá tu código de 6 dígitos. </li>
                        <li>Abre <b>Google Authenticator</b> en tu celular y consulta el código vigente. </li>
                        <li>Escríbelo en el recuadro y da clic en <b>“Verificar”.</b></li>
                        <li>Accederás a la pantalla principal.  </li>
                    </ul>

                    <p style={{color: '#757575'}}><span style={{color: '#B38600'}}><b>&#9647;&#9647; Recuerda:</b></span> Los
                        códigos cambian cada 30 segundos. Si el tiempo se agota mientras escribes, espera el siguiente código y úsalo.</p>

                    <Typography variant="h6" style={{fontWeight: "bolder"}} className="title-page-presval">
                        Preguntas frecuentes
                    </Typography>

                    <ul style={{listStyleType: "none"}}>
                        <li style={{fontWeight: "bolder"}}>¿Qué hago si pierdo mi celular o borro la aplicación?  </li>
                        <ul style={{listStyleType: "none"}}>
                            <li>No podrás acceder a tu cuenta. Solicita un “Reseteo de la verificación en dos pasos”
                                con tu administrador. </li>
                        </ul>
                        <li style={{fontWeight: "bolder"}}>¿Puedo usar la misma cuenta de Google Authenticator en otro celular?   </li>
                        <ul style={{listStyleType: "none"}}>
                            <li>Sí, pero deberás repetir el proceso de vinculación (Pasos 3 y 4) desde el nuevo dispositivo. </li>
                            <li>Si ya no tienes acceso al celular anterior, contacta a tu administrador.</li>
                        </ul>
                        <li style={{fontWeight: "bolder"}}>¿Problemas con la configuración o código no aceptado? </li>
                        <ul style={{listStyleType: "none"}}>
                            <li>Contáctanos de inmediato al correo: <a href="mailto:alertas@meipresval.com">alertas@meipresval.com</a>
                            </li>
                        </ul>
                    </ul>

                </div>
            </div>
        </Paper>
    )
}

export default class Manual2FA extends Component {
    render() {
        return <Manual2FAView />
    }
}